import React from 'react';
import { motion } from 'framer-motion';
export function ConstellationGraphic() {
  const dots = [{
    x: 50,
    y: 30,
    delay: 0
  }, {
    x: 150,
    y: 80,
    delay: 0.2
  }, {
    x: 250,
    y: 50,
    delay: 0.4
  }, {
    x: 180,
    y: 150,
    delay: 0.6
  }, {
    x: 300,
    y: 120,
    delay: 0.8
  }, {
    x: 100,
    y: 180,
    delay: 1
  }, {
    x: 280,
    y: 200,
    delay: 1.2
  }, {
    x: 200,
    y: 250,
    delay: 1.4
  }, {
    x: 350,
    y: 280,
    delay: 1.6
  }];
  const connections = [{
    from: 0,
    to: 1
  }, {
    from: 1,
    to: 2
  }, {
    from: 1,
    to: 3
  }, {
    from: 2,
    to: 4
  }, {
    from: 3,
    to: 5
  }, {
    from: 4,
    to: 6
  }, {
    from: 5,
    to: 7
  }, {
    from: 6,
    to: 8
  }, {
    from: 7,
    to: 8
  }];
  return <svg viewBox="0 0 400 320" className="w-full h-full opacity-40" style={{
    filter: 'drop-shadow(0 0 8px rgba(200, 146, 74, 0.3))'
  }} data-id="element-58">
      {/* Connection lines */}
      {connections.map((conn, i) => <motion.line key={i} x1={dots[conn.from].x} y1={dots[conn.from].y} x2={dots[conn.to].x} y2={dots[conn.to].y} stroke="#c8924a" strokeWidth="1" opacity="0.3" initial={{
      pathLength: 0
    }} animate={{
      pathLength: 1
    }} transition={{
      duration: 1.5,
      delay: 0.5
    }} data-id="element-59" />)}

      {/* Dots */}
      {dots.map((dot, i) => <motion.circle key={i} cx={dot.x} cy={dot.y} r="4" fill="#c8924a" initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: dot.delay
    }} data-id="element-60">
          <animate attributeName="opacity" values="0.6;1;0.6" dur="3s" repeatCount="indefinite" begin={`${dot.delay}s`} data-id="element-61" />
        </motion.circle>)}
    </svg>;
}